<!-- dashboard.component.html -->
<div class="amt-dashboard">
    <!-- Welcome Banner -->
    <div class="amt-welcome-banner">
        <div class="amt-welcome-content">
            <h2 class="amt-welcome-title">Welcome back, Admin!</h2>
            <p class="amt-welcome-subtitle">Here's your admin dashboard overview for Aathreya Machine Tools.</p>
        </div>
        <div class="amt-welcome-icon">
            <i class="fas fa-industry"></i>
        </div>
    </div>

    <!-- Stats Row -->
    <div class="row mt-4">
        <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
            <div class="amt-stat-card amt-stat-products">
                <div class="amt-stat-icon">
                    <i class="fas fa-boxes"></i>
                </div>
                <div class="amt-stat-info">
                    <span class="amt-stat-value">{{ totalProducts }}</span>
                    <span class="amt-stat-label">Total Products</span>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
            <div class="amt-stat-card amt-stat-categories">
                <div class="amt-stat-icon">
                    <i class="fas fa-tags"></i>
                </div>
                <div class="amt-stat-info">
                    <span class="amt-stat-value">{{ totalCategories }}</span>
                    <span class="amt-stat-label">Categories</span>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
            <div class="amt-stat-card amt-stat-enquiries">
                <div class="amt-stat-icon">
                    <i class="fas fa-envelope-open-text"></i>
                </div>
                <div class="amt-stat-info">
                    <span class="amt-stat-value">{{ totalEnquiries }}</span>
                    <span class="amt-stat-label">Enquiries</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Recent Activity & Quick Actions -->
    <div class="row mt-2">
        <div class="col-lg-4 mb-3">
            <div class="amt-card">
                <div class="amt-card-header">
                    <h5><i class="fas fa-bolt mr-2"></i>Quick Actions</h5>
                </div>
                <div class="amt-card-body">
                    <a class="amt-quick-action" (click)="navigateToAddProduct()">
                        <i class="fas fa-plus-circle"></i>
                        <span>Add Product</span>
                    </a>
                    <a class="amt-quick-action" (click)="navigateToAddCategory()">
                        <i class="fas fa-plus-circle"></i>
                        <span>Add Category</span>
                    </a>
                    <a class="amt-quick-action" (click)="navigateToAddSpecification()">
                        <i class="fas fa-plus-circle"></i>
                        <span>Add Specification</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>